export const colors = {
  all: "#3E75C3",
  bug: "#9BBA48",
  dark: "#595761",
  dragon: "#2C6AC1",
  electric: "#EED967",
  fairy: "#E296E1",
  fight: "#C44D61",
  fighting: "#C44D61",
  ground: "#CE8056",
  ice: "#8BCEC1",
  normal: "#A0A29F",
  poison: "#AC6ACA",
  psychic: "#EB8B85",
  rock: "#8BCEC1",
  ghost: "#616EB7",
  grass: "#73B861",
  steel: "#6594A1",
  water: "#88A3D4",
  fire: "#F66D6D",
  flying: "#A6BBE8",
};
